export const MAX_SUPPLIER_TOKEN_EXPIRATION_DAYS = 90;
